import { useEffect, useState } from "react";
import { getIssueReasonById } from "../services/reasonService";

const useFetchIssueReasonById = ({
  setIsLoading,
  currentReasonId,
}: {
  setIsLoading?: (loading: boolean) => void;
  currentReasonId?: string;
}) => {
  const [reasonData, setReasonData] = useState<any>(null);

  useEffect(() => {
    const fetchReason = async () => {
      if (!currentReasonId) return;

      try {
        if (setIsLoading) setIsLoading(true);
        const result = await getIssueReasonById(currentReasonId);
        setReasonData(result);
      } catch (error) {
        console.error("Error fetching reason by ID:", error);
        setReasonData(null);
      } finally {
        if (setIsLoading) setIsLoading(false);
      }
    };

    fetchReason();
  }, [currentReasonId]);

  return [reasonData];
};

export default useFetchIssueReasonById;
